import '../../shared/error-boundary.ts';
/**
 * Tool page entry — text-word-count
 */

import { wordCount } from '@bytario/core/text/word-count';
import { downloadBytes } from '../../shared/download.ts';


void downloadBytes;

async function update(): Promise<void> {
  const text = (document.querySelector('#text') as HTMLTextAreaElement).value;
  const result = await wordCount(new TextEncoder().encode(text));
  const stats = typeof result === 'object' ? result : { words: 0, characters: 0, charactersNoSpaces: 0, sentences: 0, paragraphs: 0 };
  const words = (stats as { words: number }).words ?? 0;
  const chars = (stats as { characters: number }).characters ?? text.length;
  const charsNoSpaces = (stats as { charactersNoSpaces: number }).charactersNoSpaces ?? text.replace(/\s/g, '').length;
  const sentences = (stats as { sentences: number }).sentences ?? 0;
  const paragraphs = (stats as { paragraphs: number }).paragraphs ?? 0;
  const readingMin = Math.max(1, Math.ceil(words / 238));

  document.querySelector('#stat-words')!.textContent = String(words);
  document.querySelector('#stat-chars')!.textContent = String(chars);
  document.querySelector('#stat-chars-no-spaces')!.textContent = String(charsNoSpaces);
  document.querySelector('#stat-sentences')!.textContent = String(sentences);
  document.querySelector('#stat-paragraphs')!.textContent = String(paragraphs);
  document.querySelector('#stat-reading')!.textContent = text.trim() ? readingMin + ' min' : '0 min';
}

let debounceTimer: ReturnType<typeof setTimeout>;
const DEBOUNCE_MS = 300;

const textarea = document.querySelector('#text') as HTMLTextAreaElement;
textarea.addEventListener('input', () => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(update, DEBOUNCE_MS);
});
update();
